module.exports = __webpack_public_path__ + "img/poweredby_dark.7a8a63c7.svg";